import type { FaireProductEntity } from "../../entity_types/product";

export const p_x2dvetsmwj: FaireProductEntity = {
  token: "p_x2dvetsmwj",
  type: "product",
  name: "Elephant Print Drawstring Harem Pant (TH-1027)",
  brandToken: "b_a990dearj1",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ed29b1b17f1bd8a495073076127a4a8c198448078d72ddb423390c09b1b62125.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.09,
  description:
    "Elephant print drawstring harem pant\nFree Size\nAssorted Colors Available\n",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:50.173Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
